import { ENGAGE_PATHS, engageHref } from "@/content/engage";
import { ActionLink, Container, Eyebrow } from "./primitives";

export const EngageBand = ({ path, secondary, from, title, text, testid = "engage-band" }) => (
  <section data-testid={testid} className="border-t border-o-line bg-o-surface">
    <Container className="grid gap-10 py-16 md:grid-cols-12 md:items-end lg:py-24">
      <div className="md:col-span-7">
        <Eyebrow>Contextual engagement</Eyebrow>
        <h2 className="mt-5 font-display text-2xl font-bold tracking-tight sm:text-3xl lg:text-4xl">{title}</h2>
        <p className="mt-4 max-w-xl text-o-dim">{text}</p>
      </div>
      <div className="flex flex-col gap-3 md:col-span-5 md:items-end">
        <ActionLink to={engageHref(path, from)} testid={`${testid}-primary`} className="w-full md:w-auto">
          {ENGAGE_PATHS[path].cta}
        </ActionLink>
        {secondary && (
          <ActionLink variant="line" to={engageHref(secondary, from)} testid={`${testid}-secondary`} className="w-full md:w-auto">
            {ENGAGE_PATHS[secondary].cta}
          </ActionLink>
        )}
      </div>
    </Container>
  </section>
);
